import {RefObject, useEffect} from 'react';
import {PASSIVE_TOUCH_IF_POSSIBLE} from '../constant';

// touchmove나 mousemove를 사용하는 부모 컴포넌트가 있을 때 ref만 스크롤 되도록 한다
export default function useStopPropagationOnScroll(
  ref: RefObject<HTMLElement>
) {
  useEffect(() => {
    const scrollEl = ref.current;
    function stopPropagation(e: TouchEvent | MouseEvent) {
      e.stopPropagation();
    }

    if (scrollEl) {
      scrollEl.addEventListener(
        'touchmove',
        stopPropagation,
        PASSIVE_TOUCH_IF_POSSIBLE
      );
      scrollEl.addEventListener(
        'mousemove',
        stopPropagation,
        PASSIVE_TOUCH_IF_POSSIBLE
      );
    }

    return () => {
      if (scrollEl) {
        scrollEl.removeEventListener(
          'touchmove',
          stopPropagation,
          PASSIVE_TOUCH_IF_POSSIBLE
        );
        scrollEl.removeEventListener(
          'mousemove',
          stopPropagation,
          PASSIVE_TOUCH_IF_POSSIBLE
        );
      }
    };
  }, [ref]); // ref 를 입력하는건 이상하지만, lint 에러 때문에 넣는다
}
